import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'ui-infotext-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './infotext-item.component.html',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfotextItemComponent {
  infotext = input<{
    top: number;
    maxHeight: number;
    text?: string;
    template?: TemplateRef<any>;
  }>();
}
